/**
 * ReadOnlyBanner Component
 * Displays "READ-ONLY VIEW - Underwriter Access" when in underwriter mode
 * Per WF-9 wireframe specification
 */

export interface ReadOnlyBannerProps {
  visible: boolean;
}

export function ReadOnlyBanner({ visible }: ReadOnlyBannerProps) {
  if (!visible) return null;

  return (
    <div className="bg-gray-900 dark:bg-slate-800 text-white px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-2">
      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
      READ-ONLY VIEW &mdash; Underwriter Access
    </div>
  );
}

export default ReadOnlyBanner;
